export const getLineNodesGrid = (line, initialNodesData) => {
  const node = initialNodesData.find((n) => n.line === line);

  return node;
};
